module.exports = __webpack_public_path__ + "static/img07-faaaa7b7144f570beef89a2ef3172e3e.jpg";